import { render } from "./UpdateClient.vue?vue&type=template&id=0e8ffe80"
import script from "./UpdateClient.vue?vue&type=script&lang=js"
export * from "./UpdateClient.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__